import { METHOD } from './method'

export const API_USER_MEMBERSHIP = {
    LIST: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership/list',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership/delete',
        method: METHOD.POST,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership/export',
        method: METHOD.POST,
    },
    PROFILE: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership',
        method: METHOD.GET,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership/historical-point',
        method: METHOD.GET,
    },
    EXPORT_DETAIL: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership/detail/export',
        method: METHOD.GET,
    },
    ADD_POINT: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership/add-loyalty-point',
        method: METHOD.POST,
    },
    REDUCE_POINT: {
        api: '/v1/dashboard-admin/loyalty-program/user-membership/reduce-loyalty-point',
        method: METHOD.POST,
    },
}
